import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { fetchCompany, fetchSubsidiaries } from 'src/old/actions';
import ManageEmployee from 'src/modules/ManageEmployee';
import { MODAL_TYPES } from 'src/shared/components/Modals';
import { showCustomModal } from 'src/old/actions/modal/modalActions';
import { selectCompany } from 'src/old/actions/company/companySelectors';
import { fetchBankEntities } from 'src/old/actions/bank/bankActions';
import { processEmployee } from './processEmployee';
import { useGetEmployeeByPersonalIdQuery } from 'src/shared/api/employee';
import { useGetUserHoldingQuery } from 'src/shared/api/holding';

const EditEmployee = ({ personalId }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const currentCompany = useSelector(selectCompany);

  const { data, isLoading, isError } = useGetEmployeeByPersonalIdQuery(
    { personalId },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (isLoading || isError) {
      return;
    }

    showCustomModal(modalProps(data), MODAL_TYPES.CUSTOM)(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalId, data]);

  useEffect(() => {
    Promise.all([
      fetchCompany()(dispatch),
      fetchSubsidiaries()(dispatch),
      fetchBankEntities(currentCompany?.locale)(dispatch)
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: holding } = useGetUserHoldingQuery();
  const { isoCode = 'ES' } = holding?.territory ?? {};

  const modalProps = employeeData => ({
    CustomComponent: () => <ManageEmployee employee={processEmployee(employeeData, isoCode)} edit />,
    onModalCloseCallback: () => {
      history.push('/list-employees');
    },
    align: 'left'
  });

  return <></>;
};

EditEmployee.propTypes = {
  personalId: PropTypes.string.isRequired
};

export default EditEmployee;
